const isServer = typeof window === 'undefined'

export const isServerAuthorized = (secret: string | undefined | null) => {
  if (isServer === false) return true // client side, we'll pretend it's authorized
  return secret === process.env.MUTATOR_SERVER_AUTH_SECRET
}

export const serverAuthorizedOrThrow = (secret: string | undefined) => {
  if (!secret || !isServerAuthorized(secret)) throw new Error('Unauthorized.')
}
